import { render } from "./product-form.vue?vue&type=template&id=25b96086"
import script from "./product-form.vue?vue&type=script&lang=js"
export * from "./product-form.vue?vue&type=script&lang=js"

import "./product-form.vue?vue&type=style&index=0&id=25b96086&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__